import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MomentDateModule} from '@angular/material-moment-adapter';
import {MAT_DATE_FORMATS} from '@angular/material';

import {AppRoutingModule} from './app-routing.module';
import {AuthService} from './auth/auth.service';
import {AppComponent} from './app.component';
import {ProfileComponent} from './main/profile/profile.component';
import {SharedModule} from './shared/shared.module';
import {LoginComponent} from './auth/login/login.component';
import {MAT_DISPLAY_DATE_FORMATS} from './app.constants';
import {AppInterceptor} from './app.interceptor';
import {HeaderComponent} from './main/header/header.component';
import {HomeComponent} from './main/home/home.component';
import {MenuComponent} from './main/menu/menu.component';
import { SidGraphComponent } from './main/home/sid-graph/sid-graph.component';
import { AuditModule } from './audit/audit.module';
import { ChartsModule } from 'ng2-charts';
import { MyTasksComponent } from './main/my-tasks/my-tasks.component';
import { AppMaterialModule } from './app.material.module';
import { HomeTitleComponent } from './main/home-title/home-title.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    MenuComponent,
    ProfileComponent,
    HomeComponent,    
    SidGraphComponent,
    HomeTitleComponent,
    MyTasksComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    MomentDateModule,
    ReactiveFormsModule,        
    SharedModule,
    AuditModule,
    ChartsModule,
    AppMaterialModule,
  ],
  providers: [
    AuthService,
    {provide: MAT_DATE_FORMATS, useValue: MAT_DISPLAY_DATE_FORMATS},
    {provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
